import { createContext, useContext, useState } from "react";
import { useGetDealershipUserInfo } from "../hooks/fetchDealershipUserInfo";

const DealershipUserContext = createContext({});

export const DealershipUserProvider = ({ children }) => {
  const searchString = window.location.search;
  const params = new URLSearchParams(searchString);
  const [user, setUser] = useState({});
  const [userId, setUserId] = useState(() => params.get("id") || null);
  const [openedThroughEmail, setOpenedThroughEmail] = useState(
    () => params.get("email") || "0"
  );
  const [quizIndexMapping, setQuizIndexMapping] = useState({});
  const [inventoryMatches, setInventoryMatches] = useState([]);
  const [maeTrimsMatches, setMaeTrimsMatches] = useState([]);
  const [responseMessage, setResponseMessage] = useState(null);
  const [responseError, setResponseError] = useState(null);
  const [requestPending, setRequestPending] = useState(true);

  useGetDealershipUserInfo(
    userId,
    openedThroughEmail,
    setQuizIndexMapping,
    setUser,
    setInventoryMatches,
    setMaeTrimsMatches,
    setResponseError,
    setResponseMessage,
    setRequestPending,
    setUserId,
    setOpenedThroughEmail
  );

  const clearDealershipUserInfo = () => {
    setUserId(null);
    setOpenedThroughEmail("0");
    setInventoryMatches([]);
    setQuizIndexMapping({});
    setMaeTrimsMatches([]);
    setUser({});
    setResponseMessage(null);
    setResponseError(null);
  };

  return (
    <DealershipUserContext.Provider
      value={{
        user,
        setUser,
        userId,
        setUserId,
        openedThroughEmail,
        setOpenedThroughEmail,
        quizIndexMapping,
        setQuizIndexMapping,
        inventoryMatches,
        setInventoryMatches,
        maeTrimsMatches,
        setMaeTrimsMatches,
        responseMessage,
        setResponseMessage,
        responseError,
        setResponseError,
        requestPending,
        setRequestPending,
        clearDealershipUserInfo,
      }}
    >
      {children}
    </DealershipUserContext.Provider>
  );
};

export const useDealershipUserContext = () => {
  return useContext(DealershipUserContext);
};
